// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__1vzf0","typeRadio":"Form_typeRadio__oP5ER","active":"Form_active__2y5ib","statusInput":"Form_statusInput__33TBo","fileList":"Form_fileList__erI-2"};